export class SignatureAlgorithm {
  constructor(private readonly digest: string | null, private readonly algorithm: string | null, private readonly rsaPadding: object) {}

  getDigest() {
    return this.digest ?? '';
  }

  getAlgorithm() {
    return this.algorithm ?? '';
  }

  getRsaPadding() {
    return this.rsaPadding ?? '';
  }
}
